import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, createTextVNode as _createTextVNode, mergeProps as _mergeProps, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue";
const _hoisted_1 = { class: "form" };
const _hoisted_2 = { class: "form-details" };
const _hoisted_3 = { class: "form-title" };
const _hoisted_4 = { class: "form-menu" };
const _hoisted_5 = { class: "float-end" };
const _hoisted_6 = { class: "form-contents" };
const _hoisted_7 = { class: "row" };
const _hoisted_8 = { class: "col-xs-12 col-sm-12 col-md-12" };
const _hoisted_9 = { class: "col-xs-12 col-sm-12 col-md-12" };
const _hoisted_10 = { class: "clearfix" };
const _hoisted_11 = { class: "col-xs-12 col-sm-12 col-md-6 bottom10" };
const _hoisted_12 = { class: "bottom10" };
const _hoisted_13 = { class: "invalid-feedback" };
const _hoisted_14 = {
    key: 0,
    class: "bottom10"
};
const _hoisted_15 = {
    key: 1,
    class: "bottom10"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_b_button = _resolveComponent("b-button");
    const _component_AlertComponent = _resolveComponent("AlertComponent");
    const _component_b_form_input = _resolveComponent("b-form-input");
    const _component_multiselect = _resolveComponent("multiselect");
    const _component_CollapsibleForm = _resolveComponent("CollapsibleForm");
    return _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
                _createElementVNode("h2", null, _toDisplayString(_ctx.pageTitle || 'Missing model name...'), 1 /* TEXT */)
            ]),
            _cache[8] || (_cache[8] = _createTextVNode()),
            _createElementVNode("div", _hoisted_4, [
                _createElementVNode("div", _hoisted_5, [
                    _createVNode(_component_b_button, {
                        type: "button",
                        variant: "primary",
                        onClick: _ctx.save
                    }, {
                        default: _withCtx(() => [...(_cache[3] || (_cache[3] = [
                                _createElementVNode("i", { class: "fa fa-save" }, null, -1 /* CACHED */),
                                _createElementVNode("span", { class: "hidden-xs" }, " Save", -1 /* CACHED */)
                            ]))]),
                        _: 1 /* STABLE */
                    }, 8 /* PROPS */, ["onClick"]),
                    _cache[6] || (_cache[6] = _createTextVNode()),
                    _withDirectives(_createVNode(_component_b_button, {
                        type: "button",
                        variant: "danger",
                        onClick: _ctx.deleteModel
                    }, {
                        default: _withCtx(() => [...(_cache[4] || (_cache[4] = [
                                _createElementVNode("i", { class: "fa fa-trash" }, null, -1 /* CACHED */),
                                _createElementVNode("span", { class: "hidden-xs" }, " Delete", -1 /* CACHED */)
                            ]))]),
                        _: 1 /* STABLE */
                    }, 8 /* PROPS */, ["onClick"]), [
                        [_vShow, !_ctx.isNewModel]
                    ]),
                    _cache[7] || (_cache[7] = _createTextVNode()),
                    _createVNode(_component_b_button, {
                        type: "button",
                        variant: "secondary",
                        onClick: _ctx.goBack
                    }, {
                        default: _withCtx(() => [...(_cache[5] || (_cache[5] = [
                                _createElementVNode("i", { class: "fa fa-times" }, null, -1 /* CACHED */),
                                _createElementVNode("span", { class: "hidden-xs" }, " Close", -1 /* CACHED */)
                            ]))]),
                        _: 1 /* STABLE */
                    }, 8 /* PROPS */, ["onClick"])
                ])
            ])
        ]),
        _cache[20] || (_cache[20] = _createTextVNode()),
        _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
                _createElementVNode("div", _hoisted_8, [
                    _createVNode(_component_AlertComponent, { msg: _ctx.msg }, null, 8 /* PROPS */, ["msg"])
                ]),
                _cache[19] || (_cache[19] = _createTextVNode()),
                _createElementVNode("div", _hoisted_9, [
                    _createVNode(_component_CollapsibleForm, null, {
                        default: _withCtx(() => {
                            var _a, _b, _c, _d, _e;
                            return [
                                _createElementVNode("div", _hoisted_10, [
                                    _createElementVNode("div", _hoisted_11, [
                                        _createElementVNode("div", _hoisted_12, [
                                            _cache[9] || (_cache[9] = _createElementVNode("label", null, "\r\n\t\t\t\t\t\t\t\t\t\t\tName *\r\n\t\t\t\t\t\t\t\t\t\t", -1 /* CACHED */)),
                                            _cache[10] || (_cache[10] = _createTextVNode()),
                                            _createVNode(_component_b_form_input, _mergeProps(_ctx.nameVal, {
                                                type: "text",
                                                maxlength: "150",
                                                modelValue: _ctx.model.modelName,
                                                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((_ctx.model.modelName) = $event)),
                                                modelModifiers: { trim: true },
                                                class: { 'is-invalid': (_a = _ctx.errors) === null || _a === void 0 ? void 0 : _a.name }
                                            }), null, 16 /* FULL_PROPS */, ["modelValue", "class"]),
                                            _cache[11] || (_cache[11] = _createTextVNode()),
                                            _withDirectives(_createElementVNode("div", _hoisted_13, "\r\n\t\t\t\t\t\t\t\t\t\t\t* Please enter a model name.\r\n\t\t\t\t\t\t\t\t\t\t", 512 /* NEED_PATCH */), [
                                                [_vShow, (_b = _ctx.errors) === null || _b === void 0 ? void 0 : _b.name]
                                            ])
                                        ]),
                                        _cache[17] || (_cache[17] = _createTextVNode()),
                                        (_ctx.isBatteryModel)
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                                                _createElementVNode("label", null, "\r\n\t\t\t\t\t\t\t\t\t\t\tPrice" + _toDisplayString(_ctx.currencyCode ? ` (${_ctx.currencyCode})` : ''), 1 /* TEXT */),
                                                _cache[12] || (_cache[12] = _createTextVNode()),
                                                _createVNode(_component_b_form_input, {
                                                    type: "text",
                                                    inputmode: "decimal",
                                                    modelValue: _ctx.priceInputValue,
                                                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => ((_ctx.priceInputValue) = $event)),
                                                    class: _normalizeClass({ 'is-invalid': (_c = _ctx.errors) === null || _c === void 0 ? void 0 : _c.price }),
                                                    onBlur: _ctx.onPriceBlur,
                                                    onInput: _ctx.onPriceInput
                                                }, null, 8 /* PROPS */, ["modelValue", "class", "onBlur", "onInput"]),
                                                _cache[13] || (_cache[13] = _createTextVNode()),
                                                _withDirectives(_createElementVNode("div", { class: "invalid-feedback" }, _toDisplayString((_d = _ctx.errors) === null || _d === void 0 ? void 0 : _d.price), 513 /* TEXT, NEED_PATCH */), [
                                                    [_vShow, (_e = _ctx.errors) === null || _e === void 0 ? void 0 : _e.price]
                                                ])
                                            ]))
                                            : _createCommentVNode("v-if", true),
                                        _cache[18] || (_cache[18] = _createTextVNode()),
                                        (!_ctx.isControllerModel)
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                                                _cache[15] || (_cache[15] = _createElementVNode("label", null, "\r\n\t\t\t\t\t\t\t\t\t\t\tManufacturer\r\n\t\t\t\t\t\t\t\t\t\t", -1 /* CACHED */)),
                                                _cache[16] || (_cache[16] = _createTextVNode()),
                                                _createVNode(_component_multiselect, {
                                                    modelValue: _ctx.manufacturer,
                                                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => ((_ctx.manufacturer) = $event)),
                                                    "track-by": "value",
                                                    label: "text",
                                                    placeholder: _ctx.selectPlaceholder,
                                                    options: _ctx.manufacturers,
                                                    showLabels: false,
                                                    disabled: _ctx.manufacturerIdFromRoute > 0
                                                }, {
                                                    noResult: _withCtx(() => [...(_cache[14] || (_cache[14] = [
                                                            _createTextVNode("\r\n\t\t\t\t\t\t\t\t\t\t\t\tNo results found\r\n\t\t\t\t\t\t\t\t\t\t\t", -1 /* CACHED */)
                                                        ]))]),
                                                    _: 1 /* STABLE */
                                                }, 8 /* PROPS */, ["modelValue", "placeholder", "options", "disabled"])
                                            ]))
                                            : _createCommentVNode("v-if", true)
                                    ])
                                ])
                            ];
                        }),
                        _: 1 /* STABLE */
                    })
                ])
            ])
        ])
    ], 512 /* NEED_PATCH */)), [
        [_vShow, _ctx.loaded]
    ]);
}
